import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboardList, faBoxOpen, faConveyorBelt, faBoxCheck } from '@fortawesome/pro-duotone-svg-icons'
import { Tooltip } from './styles'

const Container = styled.div`
  margin: 1em 1em 2.5em;
`

const ProgressBarWrapper = styled.div`
  position: relative;
  height: 6px;
  background: #e0e0e0;
  border-radius: 4px;
  margin: 2rem 0;
`

const ProgressFill = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  height: 6px;
  background: linear-gradient(to right, #fefb72, #f0bb31);
  border-radius: 4px;
`

const StepWrapper = styled.div<{ position: number }>`
  position: absolute;
  top: -1.3em;
  left: ${({ position }) => `${position}%`};
  transform: translateX(-50%);
  text-align: center;
`

export const StepProgressBar = ({ progress }: { progress: number }) => {
  const steps = [
    { icon: faClipboardList, label: 'Project Scheduled' },
    { icon: faBoxOpen, label: 'Project Started & Inventory Allocated' },
    { icon: faConveyorBelt, label: 'Project Assembly Complete' },
    { icon: faBoxCheck, label: 'Project Closed' },
  ]

  return (
    <Container>
      <ProgressBarWrapper>
        <ProgressFill initial={{ width: 0 }} animate={{ width: `${progress}%` }} transition={{ duration: 0.5 }} />

        {steps.map((step, i) => {
          const position = (i / (steps.length - 1)) * 100
          const accomplished = progress >= position
          return (
            <StepWrapper key={step.label} position={position}>
              <Tooltip data-title={step.label}>
                <FontAwesomeIcon
                  icon={step.icon}
                  style={{
                    filter: `grayscale(${accomplished ? 0 : 80}%)`,
                    fontSize: '2em',
                    color: '#00377d',
                    background: '#f2f3f8',
                    borderRadius: '50%',
                    padding: '0.2em',
                  }}
                />
              </Tooltip>
            </StepWrapper>
          )
        })}
      </ProgressBarWrapper>
    </Container>
  )
}
